import * as Config from '../../../../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import Header from '../../Header';
// import HeadersTouch from '../touch/HeadersTouch';

function HeadersPartial({ width, hasTitle, orderBy }) {
  const isTablet = useSelector( state => state.layoutTablet );
  // const touchEditor = useSelector( state => state.touchEditor );

  const RSizeChecker = 0; //10;
  const RSizeNumber = 30;
  const RSizeActions = isTablet ? 90 : 50;
  const RSizeCover = 48;
  const RSizeExtra = 45;
  const RSizeMore = 30;
  const RSizeKey = 90;
  const RSizeRelease = 95;
  const RSizeTime = 50;

  const RTotal = RSizeChecker + RSizeNumber + RSizeActions + RSizeCover + RSizeMore + RSizeKey + RSizeRelease + RSizeTime + RSizeExtra;
  let RSizeTrack = ((width - RTotal) * 33 / 100);
  let RSizeRemixer = ((width - RTotal) * 20 / 100);
  let RSizeLabel = ((width - RTotal) * 25 / 100);
  let RSizeGenre = ((width - RTotal) * 22 / 100);
  RSizeTrack += (Config.LIST_HEADER_HAS_REMIXER) ? 0 : RSizeRemixer;
  RSizeTrack += (Config.LIST_HAS_MORE) ? 0 : RSizeTime;

  const clearScrollUpInterval = () => {
    if (window.scrollUp) {
      window.clearInterval(window.scrollUp);
      window.scrollUp = null;
    }
  }

  return (
    <>
      <div id={`headerPartial`} onMouseEnter={clearScrollUpInterval} className={`flexRow list-container partial`} style={{ marginTop: (hasTitle) ? 32 : 0 }} >
        <Header style={{ width: RSizeChecker }} values={[]} />
        <Header style={{ width: RSizeNumber, textAlign: `center` }} values={[{value: ``, options: (orderBy && orderBy[`top`]) ? orderBy[`top`] : null}]} />
        <Header style={{ width: RSizeActions }} values={[{value: ` `}]} />
        <Header style={{ width: RSizeCover }} values={[]} />
        <Header style={{ width: RSizeTrack }} values={[
          { value: `Title`, options: (orderBy && orderBy[`title`]) ? orderBy[`title`] : null },
          { value: `Artists`, options: (orderBy && orderBy[`artists_s`]) ? orderBy[`artists_s`] : null }
        ]} />
        { (Config.LIST_HEADER_HAS_REMIXER) && (
          <Header style={{ width: RSizeRemixer }} values={[
            { value: `Remixers`, options: (orderBy && orderBy[`remixers_s`]) ? orderBy[`remixers_s`] : null },
          ]} />
        )}
        <Header style={{ width: RSizeLabel }} values={[{ value: `Label`, options: (orderBy && orderBy[`label`]) ? orderBy[`label`] : null }]} />
        <Header style={{ width: RSizeGenre }} values={[{ value: `Genre`, options: (orderBy && orderBy[`genre_s`]) ? orderBy[`genre_s`] : null }]} />
        <Header style={{ width: RSizeKey }} values={[
          { value: `Bpm`, options: (orderBy && orderBy[`bpm`]) ? orderBy[`bpm`] : null },
          { value: `Key`, options: (orderBy && orderBy[`key_camelot`]) ? orderBy[`key_camelot`] : null }
        ]} />
        <Header style={{ width: RSizeRelease }} values={[{ value: `Released`, options: (orderBy && orderBy[`release`]) ? orderBy[`release`] : null }]} />
        <Header style={{ width: RSizeTime }} values={[{ value: `Time` }]} />
        { !Config.IFRAME && <Header style={{ width: RSizeExtra }} values={[]} /> }
        { Config.LIST_HAS_MORE && <Header style={{ width: RSizeMore }} values={[]} /> }
      </div>
    </>
  )
}
// { (/*isTablet && */touchEditor) && <HeadersTouch /> }

HeadersPartial.propTypes = {
  width: PropTypes.number.isRequired,
  hasTitle: PropTypes.bool.isRequired,
  orderBy: PropTypes.array
}

export default HeadersPartial;
